// Theme handling for the app shell. The `dark` class on <html> is what
// tailwind's `darkMode: "class"` keys off; the pre-start script in
// index.html applies the stored choice before React mounts so there is
// no flash and the shell is themed even before hydration.

export const THEME_STORAGE_KEY = "tm-theme";

export type Theme = "light" | "dark";

export function getStoredTheme(): Theme {
  try {
    const v = localStorage.getItem(THEME_STORAGE_KEY);
    if (v === "light" || v === "dark") return v;
  } catch {
    /* localStorage unavailable — fall through to system preference */
  }
  return window.matchMedia?.("(prefers-color-scheme: dark)").matches
    ? "dark"
    : "light";
}

export function applyTheme(theme: Theme) {
  document.documentElement.classList.toggle("dark", theme === "dark");
  document.documentElement.style.colorScheme = theme;
}

export function setStoredTheme(theme: Theme) {
  try {
    localStorage.setItem(THEME_STORAGE_KEY, theme);
  } catch {
    /* best effort */
  }
  applyTheme(theme);
}
